import { render, staticRenderFns } from "./AdditionalTrainingInfo.vue?vue&type=template&id=3403c978&scoped=true"
import script from "./AdditionalTrainingInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalTrainingInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalTrainingInfo.vue?vue&type=style&index=0&id=3403c978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403c978",
  null
  
)

export default component.exports